<form [formGroup]="formulario">
    <mat-card>
        <mat-card-title class="matCard-Font">Revisão por planilha</mat-card-title>
        <div class="row">
            <div class="col-12 col-sm-6">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>CNPJ</mat-label>
                    <input formControlName="cnpj" matInput type="text" [mask]="masks.cnpj">
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-2">
                <mat-form-field class="formField-Font" appearance="fill">
                    <mat-label>Selecione um estado</mat-label>
                    <mat-select formControlName="cdUf">
                        <mat-option *ngFor="let uf of ufs" [value]="uf.idUF">
                            {{uf.UF}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="d-flex col-12 col-sm-3 justify-content-center">
                <button style="height: 44px;" mat-raised-button (click)="fileInput.click()" [disabled]="this.formulario.value.cnpj == null || this.formulario.value.cdUf == null"><mat-icon>add</mat-icon>Inserir
                    Planilha</button>
                <input type="file" accept=".xlsx" #fileInput hidden (change)="onFileSelected($event)">
            </div>
        </div>

        <div class="row" *ngIf="arquivoSelecionado != null">
            <div class="col-12 col-sm-6">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Arquivo Selecionado</mat-label>
                    <input formControlName="NomeArquivo" matInput type="text">
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <mat-progress-bar *ngIf="enviando" mode="determinate" [value]="progresso">
            </mat-progress-bar>

            <p *ngIf="enviando">
                {{ progresso }}%
            </p>
        </div>
    </mat-card>
</form>

<app-crud-buttons [labelBotaoPost]="'Gerar Planilha'" [showPut]="false" [showDelete]="false" [labelBotaoAuxUm]="'Limpar formulário'" [disablePost]="formulario.status == 'INVALID' || enviando == true"
    [disablePut]="formulario.status == 'INVALID'" (OnClickButtonPost)="postPlanilha(FormDataArquivo)" (OnClickButtonAuxUm)="limpar()">
</app-crud-buttons>